module.exports = __webpack_public_path__ + "img/Group22@2x.a3eb100a.png";